const countries = {
  // 🌍 Europe
  at: 'de_at',
  bg: 'bg_bg',
  be: 'nl_be',
  de: 'de_de',
  es: 'es_es',
  fr: 'fr_fr',
  hu: 'hu_hu',
  it: 'it_it',
  pl: 'pl_pl',
  pt: 'pt_pt',
  ro: 'ro_ro',
  cz: 'cs_cz',
  nl: 'nl_nl',
  sk: 'sk_sk',

  // 🌎 Americas
  ar: 'es_ar',
  br: 'pt_br',
  cl: 'es_cl',
  co: 'es_co',
  ec: 'es_ec',
  mx: 'es_mx',
  pe: 'es_pe',

  // 🌏 Oceania
  au: 'en_au',
  nz: 'en_nz',

  // 🌍 Africa
  za: 'en_za',
}

export default countries
